import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';
import '../../assets/styles/Header.css';

const Header = () => {
  const auth = getAuth();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const snap = await getDoc(doc(db, 'users', user.uid));
        if (snap.exists()) setUserData(snap.data());
      }
    };
    fetchUserData();
  }, [user]);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(setUser);
    return () => unsub();
  }, [auth]);

  const handleLogout = async () => {
    try { await signOut(auth); } catch (e) { console.error(e); }
  };

  const publicLinks = [
    { label: 'Home',        to: '/' },
    { label: 'About',       to: '/about' },
    { label: 'Packages',    to: '/packages' },
    { label: 'Get started', to: '/get-started' },
  ];

  const clientLinks = [
    { label: 'Dashboard', to: '/client' },
    { label: 'Upload',    to: '/client/upload' },
    { label: 'Account',   to: '/client/my-account' },
  ];

  const adminLinks = [
    { label: 'Dashboard', to: '/admin' },
  ];

  const links = !user ? publicLinks : userData?.isAdmin ? adminLinks : clientLinks;

  return (
    <nav className="site-nav">
      <div className="nav-inner">

        {/* Logo */}
        <Link className="brand" to="/">
          <img src="/NLW-logo.png" alt="Next Level Websites" />
        </Link>

        {/* Desktop pill list */}
        <ul className="pill-list">
          {links.map(({ label, to }) => (
            <li key={to}>
              <Link
                className={`nav-link${location.pathname === to ? ' active' : ''}`}
                to={to}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile dropdown */}
        <div className="pill-dropdown">
          <button className="nav-pill-toggle" onClick={() => setDropdownOpen(o => !o)}>
            Menu
          </button>
          {dropdownOpen && (
            <ul className="nav-pill-dropdown">
              {links.map(({ label, to }) => (
                <li key={to} className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Login / Logout */}
        {user
          ? <button className="btn-login" onClick={handleLogout}>Logout</button>
          : <Link className="btn-login" to="/login">Login</Link>
        }

      </div>
    </nav>
  );
};

export default Header;
